import React from 'react';
import { Modal, Pressable, StyleSheet, useWindowDimensions, View } from 'react-native';

import { GlassSurface } from '../../components/ui/glass';
import { colors, spacing } from '../../core/theme/tokens';
import { useImportOnboarding } from '../../contexts/ImportOnboardingContext';
import { ImportOnboardingModalContent } from './ImportOnboardingModalContent';

const PANEL_PADDING_V = spacing.lg + spacing.md;

/** Web: centered glass panel for first-run screenshot import. */
export function ImportOnboardingModal() {
  const { width, height } = useWindowDimensions();
  const { isModalVisible, close, busy } = useImportOnboarding();
  const isWide = width >= 768;
  const panelWidth = Math.min(isWide ? 560 : width - 32, width - 24);
  const panelMaxHeight = Math.round(height * (isWide ? 0.82 : 0.92));
  const contentMaxHeight = Math.max(320, panelMaxHeight - PANEL_PADDING_V);

  return (
    <Modal
      visible={isModalVisible}
      transparent
      animationType="fade"
      onRequestClose={close}
    >
      <View style={styles.backdrop}>
        <Pressable
          style={StyleSheet.absoluteFill}
          onPress={close}
          accessibilityLabel={
            busy ? 'Hide import sheet — import continues in background' : 'Dismiss import onboarding'
          }
        />
        <View
          style={[styles.panelWrap, { width: panelWidth, height: panelMaxHeight }]}
          pointerEvents="box-none"
        >
          <View style={styles.panelHit} pointerEvents="auto">
            <GlassSurface
              tint="neutral"
              rounded="xl"
              showHairline
              style={styles.panel}
              contentStyle={styles.panelContent}
            >
              <ImportOnboardingModalContent maxHeight={contentMaxHeight} />
            </GlassSurface>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(2, 6, 23, 0.72)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.md,
  },
  panelWrap: {
    zIndex: 2,
  },
  panelHit: {
    flex: 1,
  },
  panel: {
    flex: 1,
    height: '100%',
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.lg,
    paddingBottom: spacing.md,
    backgroundColor: colors.surfaceElevated,
  },
  panelContent: {
    flex: 1,
    minHeight: 0,
  },
});
